import { render, staticRenderFns } from "./speakLoading.vue?vue&type=template&id=ca08a1a8&scoped=true&"
import script from "./speakLoading.vue?vue&type=script&lang=js&"
export * from "./speakLoading.vue?vue&type=script&lang=js&"
import style0 from "./speakLoading.vue?vue&type=style&index=0&id=ca08a1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08a1a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca08a1a8')) {
      api.createRecord('ca08a1a8', component.options)
    } else {
      api.reload('ca08a1a8', component.options)
    }
    module.hot.accept("./speakLoading.vue?vue&type=template&id=ca08a1a8&scoped=true&", function () {
      api.rerender('ca08a1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/speakLoading.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/speakLoading.vue
// module id = E0Us
// module chunks = 0